import { Award } from "lucide-react";

const certifications = [
  {
    name: "OSCP+",
    issuer: "Offensive Security",
    description:
      "Advanced penetration testing certification with additional modules",
    color: "from-red-500 to-orange-500",
    url: "https://credentials.offsec.com/f09def7d-dd2b-4939-bcff-638556bf74eb",
    img: "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/169499652",
  },
  {
    name: "OSCP",
    issuer: "Offensive Security",
    description:
      "Offensive Security Certified Professional - hands-on penetration testing",
    color: "from-red-600 to-red-400",
    url: "https://credentials.offsec.com/56c221dd-548e-4e19-a559-b845e36fe3e8",
    img: "https://api.accredible.com/v1/frontend/credential_website_embed_image/badge/169499619",
  },
  {
    name: "CRTO",
    issuer: "Zero-Point Security",
    description:
      "Certified Red Team Operator - adversary simulation and red teaming",
    color: "from-purple-500 to-pink-500",
    url: "https://badges.parchment.eu/backpack/badges/65bd9eae1a752c15a777df10",
    img: "https://api.eu.badgr.io/public/assertions/OIrbASmyS3igIT3vn4t8mA/image",
  },
  {
    name: "AWS",
    issuer: "Amazon Web Services",
    description: "AWS Technical Accreditation for cloud security",
    color: "from-orange-500 to-yellow-500",
    url: "https://www.credly.com/badges/7d43091d-52a6-4ef0-b6fa-5f8f100970cc/public_url",
    img: "https://images.credly.com/size/340x340/images/8f006312-3154-45bf-a845-4a043641e83c/blob",
  },
  {
    name: "SAFe 5.0",
    issuer: "Scaled Agile (2022-2023)",
    description: "Certified Agilist - enterprise agile framework",
    color: "from-green-500 to-teal-500",
    url: "https://www.credly.com/badges/73ee750e-4d0e-4a91-bd80-00b8d21e74c6",
    img: "https://images.credly.com/size/340x340/images/969ca68c-6793-4ebc-b35a-1d2663ad3c26/cert_mark_SA_badge_large_300px.png",
  },
];

const Certifications = () => {
  return (
    <section id="certifications" className="py-24 relative">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="font-mono text-sm text-primary mb-4">
            {">"} gpg --verify certifications.sig
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Verified <span className="text-primary text-glow">Credentials</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Industry-recognized certifications validating expertise in offensive
            security and cloud technologies.
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto stagger-children">
          {certifications.map((cert, index) => (
            <div key={cert.name} className="group cyber-card p-6 hover-lift">
              {/* Badge icon with gradient */}
              <div
                className={`w-16 rounded-xl bg-gradient-to-br flex items-center justify-center mb-4 transition-transform`}
              >
                <a
                  key={index}
                  href={cert.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="badge-image">
                    <img
                      src={cert.img}
                      alt={`Certification Badge ${index + 1}`}
                      className="badge"
                    />
                  </div>
                </a>
              </div>

              <h3 className="text-xl font-bold mb-1">{cert.name}</h3>
              <p className="text-sm text-primary font-mono mb-3">
                {cert.issuer}
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {cert.description}
              </p>
            </div>
          ))}
        </div>

        {/* Education */}
        <div className="mt-20 max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-center mb-8">
            <span className="text-primary">{">"}</span> Education
          </h3>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="cyber-card p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-primary/10">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold">BSc. in Computer Science</h4>
                  <p className="text-sm text-muted-foreground clean-text">
                    University of Gävle
                  </p>
                  <p className="text-sm text-muted-foreground clean-text">
                    2017-2020
                  </p>
                </div>
              </div>
            </div>

            <div className="cyber-card p-6 hover-lift">
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-secondary/10">
                  <Award className="w-6 h-6 text-secondary" />
                </div>
                <div>
                  <h4 className="font-semibold">Masters Exchange Program</h4>
                  <p className="text-sm text-muted-foreground clean-text">
                    University of Ghent - Geomatics
                  </p>
                  <p className="text-sm text-muted-foreground clean-text">
                    2019-2020
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
